import { render, staticRenderFns } from "./delete-library-player-template.vue?vue&type=template&id=0586c8e0&"
import script from "./delete-library-player-template.vue?vue&type=script&lang=js&"
export * from "./delete-library-player-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports